export default [
    {
      path: '/offers',
      name: 'offers',
      component: () => import('@/views/sft/Offers.vue'),
    },
  ]